import React from "react";
import { t } from "i18next";

export function ImprimerTicket(props: any): JSX.Element {
    const label = t("imprimerTicket", { lng: props.selectedLanguage });
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={props.width}
            height={props.height}
            viewBox="0 0 350 87"
            role="img"
            aria-label={label}
        >
            <title>{label}</title>
            <g id="ImprimerTicket" data-name="ImprimerTicket">
                <rect
                    width="350"
                    height="87"
                    rx="9"
                    fill="#323333"
                />
                <text
                    x="175"
                    y="58"
                    textAnchor="middle"
                    fill="#fff"
                    font-size="38"
                    font-family="HelveticaNeue-Medium, Helvetica Neue"
                    font-weight="500"
                >
                    {label}
                </text>
            </g>
        </svg>
    );
}
